import { CSSProperties, FC, HTMLAttributes } from 'react';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

import { getDropPlaceholderStyle } from './platformStyles';

interface DropPlaceholderProps extends Omit<HTMLAttributes<HTMLDivElement>, 'style'> {
    style?: CSSProperties;
}

/** Renders the shared destination marker without affecting measured layout. */
const DropPlaceholder: FC<DropPlaceholderProps> = ({ style, ...props }) => {
    const { token } = useAntDesignTheme();

    return (
        <div
            aria-hidden
            data-platform-drop-placeholder='true'
            style={getDropPlaceholderStyle(style, token)}
            {...props}
        />
    );
};

export default DropPlaceholder;
